const NOTE_NAMES = [
  'C',
  'C#',
  'D',
  'D#',
  'E',
  'F',
  'F#',
  'G',
  'G#',
  'A',
  'A#',
  'B',
]

export function clampChartOverlayValue(
  value: number,
  min: number,
  max: number,
): number {
  return Math.min(max, Math.max(min, value))
}

export function formatVoiceAssessmentChartDate(
  date: Date,
  locale: string,
): string {
  return date.toLocaleDateString(locale, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  })
}

export function noteLabelForPosition(position: number): string {
  const normalized = ((position % 12) + 12) % 12
  const octave = Math.floor(position / 12)
  return `${NOTE_NAMES[normalized] ?? 'C'}${String(octave)}`
}
